export enum Routes {
  ActivityPanel = 'Painél de Atividade',
  Audit = 'Auditoria',
  Availability = 'Disponibilidade',
  BrokenChargers = 'Carregadores com defeito',
  BusinessPlans = 'Planos de negócios',
  ChargerGroup = 'Grupo de Carregadores',
  Chargers = 'Carregadores',
  Circuits = 'Circuitos',
  ChargersReport = 'Pagamentos de sessões',
  ChargingStations = 'Eletropostos',
  ClearMobileIdentifier = 'Limpar identificador de Celular',
  CustomerGroups = 'Grupos de clientes',
  Customers = 'Clientes',
  ContactRegistration = 'Cadastro de Contato',
  ExpiredBills = 'Falhas de cobrança',
  Financial = 'Financeiro',
  Fleets = 'Frotas',
  Locations = 'Eletropostos',
  LocationCategories = 'Categorias de eletropostos',
  MapPanel = 'Painél de Mapa',
  Nfses = 'NFSes',
  Notifications = 'Notificações',
  NotificationTypes = 'Tipos de notificação',
  OcpiLocations = 'OCPI Locations',
  OperationsPanel = 'Painel de Operações',
  Partners = 'Parceiros',
  ProblemTypes = 'Tipos de defeito',
  RechargeOperationCenter = 'Centro de Operação de Recargas',
  Readiness = 'Prontidão da frota',
  RechargeStatus = 'Status das Recargas',
  Reimbursement = 'Reembolso',
  Reservations = 'Reservas',
  Schedules = 'Agendamentos',
  SessionPayment = 'Pagamentos de sessões',
  SessionsList = 'Sessões - Listagem',
  SessionsPanel = 'Painél de Sessões',
  Tariffs = 'Tarifas',
  TicketRegistration = 'Cadastro de Chamados',
  Users = 'Usuários',
  VehicleModels = 'Modelos de veículos',
  Vehicles = 'Veículos',
  VentureRegistration = 'Cadastro de Empreendimentos',
  VinNumbers = 'Códigos Vin',
  Vouchers = 'Vouchers',
  VoucherUsage = 'Utilização de vouchers',
}
